<template>
  <component
    :is="component"
    type="button"
    :target="target"
    v-bind="{
      ...(to ? { to } : {}),
      ...(href ? { href } : {}),
    }"
    class="group overflow-hidden block relative text-left font-bold text-base appearance-none w-full"
    :class="[
      isLoading ? 'pointer-events-none' : '',
      getStyle(styles, 'container'),
      h
    ]"
    :style="theme ? {
      background: theme.base.background.xweak,
      color: theme.base.text.base
    } : {
      ...(color === 'holo' ? { backgroundImage: `url(${holo})` } : {})
    }"
  >
    <div
      class="flex items-center space-x-2.5 align-middle relative" 
      :class="[
        size === 'base' ? 'min-h-[3.3rem] py-2.5 px-3.5' : '',
        size === 'sm' ? 'px-3.5 py-3' : '',
        size === 'xs' ? 'px-1 py-3' : ''
      ]"
    >
      <div class="text-center w-6 relative z-10" v-if="icon || image">
        <IconBase :name="icon" class="shrink-0" v-if="icon" />
        <ImageEmoji :name="image" class="size-6" size="sm" v-else-if="image" />
      </div>

      <div class="grow">
        <slot />
      </div>

      <IconBase name="cute/spinner" :width="20" v-if="isLoading && iconRight !== 'none'" class="relative z-10 spin text-charcoal-600" />
      <IconBase :name="iconRight" :width="20" v-else-if="iconRight && iconRight !== 'none'" class="relative z-10 text-charcoal-400" />
    </div>
  </component>
</template>

<script lang="ts" setup>
import holo from '@/assets/img/bg/holo.jpg'
import { defineStyles, getStyle } from '@/utils/useStyles'
import { Theme } from '@/classes'

const props = withDefaults(defineProps<{
  href?: string
  to?: RouteLocationRaw
  theme?: Theme | null
  color?: 'white' | 'urchin' | 'holo' | 'transparent'
  target?: '_blank' | '_self'
  size?: 'base' | 'sm' | 'xs'
  icon?: string
  iconRight?: string
  isLoading?: boolean
  image?: string
}>(), {
  href: undefined,
  to: undefined,
  theme: null,
  icon: '',
  color: 'white',
  size: 'base',
  isLoading: false,
  iconRight: 'cute/angle-right',
  target: '_self',
  image: ''
})


const styles = computed(() => defineStyles({
  container: {
    color: {
      white: 'bg-white text-light-950 dark:bg-dark-700 dark:text-dark-50',
      urchin: 'bg-urchin-100 text-urchin-950',
      holo: 'text-light-950 bg-cover',
      whale: 'text-white bg-whale-950',
    }
  }
}, props))
      

const component = computed(() => {
  if (props.href) return 'a'
  if (props.to) return resolveComponent('NuxtLink')

  return 'button'
})
</script>